import React from 'react';
import Path from '@leverege/path';
import S from './FileInput.css';
import Button from "./Button.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default class FileInput extends React.Component {
  constructor(props) {
    super(props);
    this.inputRef = /*#__PURE__*/React.createRef();
  }
  onChange = e => {
    e.preventDefault();
    const files = Path.get('current/files', this.inputRef);
    const {
      onChange,
      eventData
    } = this.props;
    if (files instanceof FileList && typeof onChange === 'function') {
      onChange({
        data: eventData,
        value: [...files],
        sourceEvent: e
      });
      this.inputRef.current.value = null;
    }
  };
  focusInput = () => {
    this.inputRef.current.click();
  };
  render() {
    const {
      children,
      fileTypes,
      capture,
      files,
      multiple,
      variant = '',
      ...rest
    } = this.props;
    const inputProps = {
      capture,
      files,
      multiple
    };
    if (Array.isArray(fileTypes)) {
      inputProps.accept = fileTypes.join(',');
    } else if (typeof fileTypes === 'string') {
      inputProps.accept = fileTypes;
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: this.focusInput,
        variant: variant,
        ...rest,
        children: children
      }), /*#__PURE__*/_jsx("input", {
        type: "file",
        name: "upload",
        onChange: this.onChange,
        size: "0",
        className: S.fileInput,
        ref: this.inputRef,
        ...inputProps
      })]
    });
  }
}